var map = {
	"./car-entrega.svg": "58e0",
	"./car-poupa.svg": "8b5b",
	"./car-style_comfort.svg": "7a22",
	"./car-style_pop.svg": "b52b",
	"./car-style_taxicomum.svg": "0ea8",
	"./car-style_top.svg": "cc2e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b64";